import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const ContragentPage = lazy(
  () => import("../../../../components/WMS/Contragents/ContragentPage"),
)

export const Route = createFileRoute("/_layout/WMS/contragents/$contragentId")({
  component: ContragentRoute,
})

function ContragentRoute() {
  return (
    <LazyRoutePage>
      <ContragentPage />
    </LazyRoutePage>
  )
}
